import { jsx as _jsx } from "react/jsx-runtime";
import { VideoCard } from './VideoCard';
export var VideoGrid = function (_a) {
    var videos = _a.videos, onVideoSelect = _a.onVideoSelect, loading = _a.loading;
    if (loading) {
        return (_jsx("div", { className: "flex items-center justify-center min-h-[400px]", children: _jsx("div", { className: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" }) }));
    }
    if (!videos.length) {
        return (_jsx("div", { className: "flex items-center justify-center min-h-[400px]", children: _jsx("p", { className: "text-gray-500 text-lg", children: "No videos found" }) }));
    }
    return (_jsx("div", { className: "w-full", children: _jsx("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8", children: videos.map(function (video) { return (_jsx("div", { className: "flex justify-center", children: _jsx(VideoCard, { video: video, onClick: function () { return onVideoSelect(video); } }) }, video.id)); }) }) }));
};
